import { cloneDeep } from 'lodash';
import { setSearchResults } from './search_results';
import { fireSearchLoading, setSearchLoadingFalse } from './search_loading';
import { setMaps, buildMaps } from './maps';
import { setGenres } from './genres';
import { setFeedback, delayedClearFeedback } from './feedback';
import { setProducts } from './products';
import { setCategories } from './categories';
import { setPath } from './path';
import { setPromos } from './promos';
import request from 'superagent';

const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
const initialStateSearchQuery = 'Search';

export default function reducer(state = cloneDeep(initialStateSearchQuery), action) {
	switch (action.type) {
		case SET_SEARCH_QUERY:
			return action.payload;
		default:
			return state;
	}
}

export function setSearchQuery(query){
	return {
		type: SET_SEARCH_QUERY,
		payload: query
	}
}

  //handler in ie9 for link to /search?xxx
export function handleSearchNoRedirect(){
	return (dispatch, getState) => {
    let sQuery = window.location.search.substr(1);
    request
      .get('/svc/search/search/?q=' + sQuery + '&size=100')
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200)
          return dispatch([
            setFeedback( "Search error. Please try again."),
            delayedClearFeedback()
          ]);

        let oSearchResults = res.body.result.hits;
        let aProductResults = res.body.products || [];
        let oMaps = buildMaps(aProductResults, getState().maps);
        return dispatch([
          setMaps( oMaps.maps ),
          setCategories( oMaps.categories ),
          setGenres( oMaps.genres ),
          setPromos( oMaps.promos ),
          setProducts( oMaps.products ),
          setSearchResults(oSearchResults),
          setSearchQuery(sQuery),
          setSearchLoadingFalse()
        ]);
      });
  }
}

  //normal search handler
export function handleSearch(sQuery){
	return (dispatch, getState) => {
    dispatch(fireSearchLoading());
    request
      .get('/svc/search/search/?q=' + sQuery + '&size=100')
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200 ) return alert('search error');
        let oSearchResults = res.body.result.hits;
        let aProductResults = res.body.products || [];
        let oMaps = buildMaps(aProductResults, getState().maps);
        let sPathName = '/search?' + sQuery;

        dispatch([
          setMaps( oMaps.maps ),
          setCategories( oMaps.categories ),
          setGenres( oMaps.genres ),
          setPromos( oMaps.promos ),
          setProducts( oMaps.products ),
          setSearchResults(oSearchResults),
          setSearchQuery(sQuery),
          setSearchLoadingFalse(),
          setPath('/search')
        ]);

        if (!window || !window.history.pushState){
          window.navigate( sPathName );
          return;
        }

        window.history.pushState(null, null, sPathName);
        window.scrollTo(0,0);
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/search_query.js